import initCarousel from '../helpers/carousel';

export default class MainAnnouncementBar {
  constructor(section) {
    this.el = section.el;
    this.splide = initCarousel(
      this.el,
      {
        type: 'loop',
        perPage: 1,
        perMove: 1,
        gap: '0',
        pagination: false,
        arrows: true,
        drag: true,
      },
      true,
    );
  }

  onSectionUnload() {
    if (this.splide) {
      this.splide.destroy();
      this.splide = null;
    }
  }
}
